import { RenderInstruction } from "aurelia-validation";

export abstract class FormRenderer{
    public abstract render(instruction: RenderInstruction);
}   